// import { loginByUsername, logout, getUserInfo } from '@/api/user'
import { loginByUsername, getUserInfo } from '@/api/user'
import { setToken, removeToken } from '@/utils/auth'
import { setUsername, removeUsername } from '@/utils/auth'
import { setNickname, removeNickname } from '@/utils/auth'
import { setAvatar, removeAvatar } from '@/utils/auth'
import { setRoles, removeRoles } from '@/utils/auth'

import { getLocalStorageToken, setLocalStorageToken, removeLocalStorageToken } from '@/utils/auth'
import { getLocalStorageUsername, setLocalStorageUsername, removeLocalStorageUsername } from '@/utils/auth'
import { getLocalStorageNickname, setLocalStorageNickname, removeLocalStorageNickname } from '@/utils/auth'
import { getLocalStorageAvatar, setLocalStorageAvatar, removeLocalStorageAvatar } from '@/utils/auth'
import { getLocalStorageRoles, setLocalStorageRoles, removeLocalStorageRoles } from '@/utils/auth'
import { getLocalStorageUserId, setLocalStorageUserId, removeLocalStorageUserId } from '@/utils/auth'
// import {  getToken,removeToken } from '@/utils/auth'

const user = {
  //全局变量
  state: {
    token: getLocalStorageToken(),
    // token: "",
    username: getLocalStorageUsername(),
    nickname: getLocalStorageNickname(),
    avatar: getLocalStorageAvatar(),
    roles: getLocalStorageRoles(),
    userId: getLocalStorageUserId(),
  },

  //设置值的方法
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
  },

    // getters:{
    //     username: state => state.username
    // },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      // const code = userInfo.code
      return new Promise((resolve, reject) => {
          loginByUsername(username, password).then(res => {
            // console.log(res.msg)
            setToken(res.data)
            setLocalStorageToken(res.data);
            commit('SET_TOKEN', res.data);
            resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
          getUserInfo(state.token).then(res => {
          // const user = res.user
          // const avatar = user.avatar == "" ? require("@/assets/image/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
          // const avatar = "";
          if (res.code===200){
              if (res.data.roles && res.data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                  setRoles(res.data.roles);
                  setLocalStorageRoles(res.data.roles);
                  commit('SET_ROLES', res.data.roles);
              } else {
                  commit('SET_ROLES', ['ROLE_DEFAULT']);
              }

              setUsername(res.data.username);
              setNickname(res.data.nickName);
              setAvatar(res.data.avatar);

              setLocalStorageUsername(res.data.username);
              setLocalStorageNickname(res.data.nickName);
              setLocalStorageAvatar(res.data.avatar);
              setLocalStorageUserId(res.data.id);

              commit('SET_USERNAME', res.data.username);
              commit('SET_NICKNAME', res.data.nickName);
              commit('SET_AVATAR', res.data.avatar);

              resolve(res)
          } else {
              removeToken();
              removeUsername();
              removeNickname();
              removeAvatar();
              removeRoles();

              removeLocalStorageToken();
              removeLocalStorageUsername();
              removeLocalStorageNickname();
              removeLocalStorageAvatar();
              removeLocalStorageRoles();
              removeLocalStorageUserId();

              commit('SET_TOKEN', "");
              commit('SET_ROLES', "");
              commit('SET_USERNAME', "");
              commit('SET_NICKNAME', "");
              commit('SET_AVATAR', "");
          }
        }).catch(error => {
            console.log(error)
            reject(error);
        })
      })
    },

    // // 退出登录（通过后端退出）
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //         console.log("test")
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       commit('SET_PERMISSIONS', [])
    //       commit('SET_USERNAME', "")
    //       commit('SET_AVATAR', "")
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 前端退出登录(没有通过给后端退出)
    LogOut({ commit}) {
        return new Promise((resolve) => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            commit('SET_USERNAME', "");
            commit('SET_AVATAR', "");

            removeToken();
            removeUsername();
            removeNickname();
            removeAvatar();
            removeRoles() ;

            removeLocalStorageToken();
            removeLocalStorageUsername();
            removeLocalStorageNickname();
            removeLocalStorageAvatar();
            removeLocalStorageRoles();
            removeLocalStorageUserId();

            resolve({code:200,msg:"帐号正在退出"})
        })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removeLocalStorageToken()
        resolve()
      })
    }
  }
}

export default user
